import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.filter((a) => a.featured);

export default function FeaturedArticles() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              编辑精选优质内容，深度解读亚洲文化、娱乐与资讯
            </p>
          </div>
          <Link
            to="/category/zixun"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, index) => (
            <article
              key={article.id}
              className={`group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.01] ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <Link to={`/article/${article.id}`} className="block">
                <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[16/9] lg:aspect-[21/9]' : 'aspect-[16/9]'}`}>
                  <img
                    src={article.image}
                    alt={article.imageAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={article.imageAlt}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500 text-white">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-2 ${
                    index === 0 ? 'text-lg md:text-xl' : 'text-base'
                  }`}>
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i> {article.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                    </span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-6 sm:hidden text-center">
          <Link
            to="/category/zixun"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}